import { Injectable } from '@angular/core';
import { AuthRepository } from '@data/auth/auth.repository';
import { PostAuthDto } from '@data/auth/dto';
import { AuthService } from '@infra/auth/auth.service';
import { map } from 'rxjs';

@Injectable()
export class LoginController {
  constructor(
    private authService: AuthService,
    private authRepository: AuthRepository,
  ) {}

  login(data: PostAuthDto) {
    return this.authRepository.postAccessToken(data).pipe(
      map((item) => {
        this.authService.credentials = item;
        return item;
      })
    );
  }
}
